import { bbxKind } from '../agents/bbx-kind.js';
import { OcrExtractionType } from '../agents/extraction-modules/ocrExtractionTypes.js';
import { type TaskTypeBehaviour } from './task-main.js';

export const taskFrameBehaviour = {
  implemented: true,
  structureAgentPrompt:
    'The TASK_FRAME type is a special task type. Assign it to tasks that do not require a direct answer from the student, but rather serve solely as grouping or additional description for subtasks. Note a subtask itself can again be of type TASK_FRAME, if it just groups or describes further subtasks.',
  examCreationPrompt:
    'Assign TASK_FRAME to a task that groups/introduces its subtasks and answers nothing itself (answer: "none") — a subtask can be TASK_FRAME too if it only groups further subtasks. Never give TASK_FRAME to a task with no subtasks of its own.',
  boundingBox: {
    [bbxKind.STUDENT_ANSWER]: '',
    [bbxKind.MS]: '',
    [bbxKind.GS]: '',
    [bbxKind.TASKS]: '',
  },
  OCR: {
    [OcrExtractionType.STUDENT_ANSWER]: '',
    [OcrExtractionType.TASK_DESCRIPTION]: '',
    [OcrExtractionType.MASTER_SOLUTION]: '',
    [OcrExtractionType.GRADING_CRITERIA]: '',
  },
  generateMS: '',
  generateGS: '',
  grading: '',
} satisfies TaskTypeBehaviour;
